import { useRedlMetadata } from 'hooks/useRedlMetadata';
import { useEffect, useState } from 'react';
import { useDelivertyUser } from 'hooks/useDelivertyUser';

export const usePageEditMode = (props, router) => {
    const { layout, rawLayout } = props;
    const [genericPageProps, setGenericPageProps] = useState(props);
    const { setRedlPageMetadata, getRedlPageMetadata, setRedlPageRawLayout, resetRedlNotRenderableInfo} = useRedlMetadata(router.pathname);
    const { isEditModeEnable } = useDelivertyUser();

    useEffect(() => {
        if (isEditModeEnable) {
            resetRedlNotRenderableInfo();
            setRedlPageMetadata(layout.allData, layout.structure, layout.components, layout.layoutURLHost, layout.blocREDLSchema);
            setRedlPageRawLayout(rawLayout);
        }
    }, [isEditModeEnable, layout, rawLayout, setRedlPageMetadata, setRedlPageRawLayout, resetRedlNotRenderableInfo]);

    useEffect(() => {
        if (isEditModeEnable) {
            const pageMetadata = getRedlPageMetadata();
            if (pageMetadata
                && pageMetadata.structure
                && pageMetadata.editId
            ) {
                const { structure, editId } = pageMetadata;
                setGenericPageProps((prevState) => {
                    if (prevState.layout.editId !== editId) {
                        return { ...prevState, layout: { ...layout, structure, editId } };
                    }
                    return prevState;
                });
            }
        }
    }, [isEditModeEnable, getRedlPageMetadata, layout, genericPageProps.editId]);

    return genericPageProps;
};